import { types } from "../actions";

const initialState = {
  users: [],
  userGroups: [],
  pendingInvites: [],
};

const userManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_USER_MANAGEMENT_USERS:
      return { ...state, users: action.payload };
    case types.SET_USER_MANAGEMENT_GROUPS:
      return { ...state, userGroups: action.payload };
    case types.SET_USER_MANAGEMENT_PENDING_INVITES:
      return { ...state, pendingInvites: action.payload };
    default:
      return state;
  }
};

export default userManagementReducer;
